 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		9: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"80a5ef906c00ddf5a39ef8dae21ccd4a61f15c69","3":"73578d5199b4d25220561732e5c3d040965c3d2e","4":"35fc8c20","5":"b35971fe2db1c9730b651c6a7f89f5bd5c72c54a","6":"8958a65904f2d4b1fb4a7e3327e99fe63d4db0d4","7":"a71dabd864de05638b49f8b70261c411cda1ef4e","8":"9519e63b9c9875fead001173bf2ac561d3fdf0c5","11":"component---src-pages-404-js","12":"component---src-pages-index-js","13":"component---src-templates-about-js","14":"component---src-templates-athena-issue-js","15":"component---src-templates-athena-issues-js","16":"component---src-templates-careers-index-js","17":"component---src-templates-case-study-js","18":"component---src-templates-contact-index-js","19":"component---src-templates-contact-success-js","20":"component---src-templates-custom-articles-cycle-1-defining-audiences-js","21":"component---src-templates-custom-articles-cycle-1-dscout-js","22":"component---src-templates-custom-articles-cycle-1-face-filters-js","23":"component---src-templates-custom-articles-cycle-1-fluid-brand-js","24":"component---src-templates-custom-articles-cycle-1-octopuses-js","25":"component---src-templates-custom-articles-cycle-1-you-dont-know-me-js","26":"component---src-templates-custom-articles-cycle-2-alternate-economies-js","27":"component---src-templates-custom-articles-cycle-2-interview-js","28":"component---src-templates-custom-articles-cycle-2-introduction-js","29":"component---src-templates-custom-articles-cycle-2-octopus-part-2-js","30":"component---src-templates-custom-articles-cycle-2-wayfinding-js","31":"component---src-templates-custom-articles-cycle-3-collective-genius-js","32":"component---src-templates-custom-articles-cycle-3-cooperative-aesthetics-js","33":"component---src-templates-custom-articles-cycle-3-cooperative-mindset-js","34":"component---src-templates-custom-articles-cycle-3-new-impact-models-js","35":"component---src-templates-custom-articles-cycle-4-endlesss-js","36":"component---src-templates-custom-articles-cycle-4-engestation-js","37":"component---src-templates-custom-articles-cycle-4-flourishing-js","38":"component---src-templates-custom-articles-cycle-4-joy-can-lead-us-js","39":"component---src-templates-custom-articles-cycle-4-rethinking-js","40":"component---src-templates-custom-articles-cycle-4-sounds-js","41":"component---src-templates-custom-articles-cycle-4-vocab-js","42":"component---src-templates-custom-articles-cycle-5-default-js","43":"component---src-templates-endlesss-js","44":"component---src-templates-expertise-entry-js","45":"component---src-templates-expertise-index-js","46":"component---src-templates-newsletter-js","47":"component---src-templates-people-js","48":"component---src-templates-person-js","49":"component---src-templates-private-js","50":"component---src-templates-project-js","51":"component---src-templates-recruit-index-js","52":"component---src-templates-recruit-success-js","53":"component---src-templates-tertiary-page-js","54":"component---src-templates-works-js"}[chunkId]||chunkId) + "-" + {"0":"dee7a0ac941e2e222701","1":"e9d24b1846c7d6eb9685","2":"881d709c9ce7ecfd7289","3":"368560596d67d095033d","4":"2644160058bf08d1de1c","5":"99b6ee7ddb14741f43d3","6":"b80c64e6e8070d998c0b","7":"87b711b9a8d230a6f470","8":"9e7cb40568a405e633c8","11":"7b280a7237de09af7241","12":"30f7cdf8a41edea618ec","13":"8d103625385529364d35","14":"61bea1c9f1dde5666901","15":"2b148a96a6c158485a4c","16":"5ecff4813fede8e7f9a5","17":"8e2f1953982b9ed1381a","18":"eb1baf43ecc887be1011","19":"7fd6aaa2470d74bb22b8","20":"d06bddd982c36a93e120","21":"ebc995403472fd4593be","22":"d576844ed3984277d9d8","23":"ad81e32af4d26c52e097","24":"768e72e5d46f645f4115","25":"60509cb86a9c4bc1394e","26":"e1ea08682edb8ea35e0f","27":"32454fd082ba204345ae","28":"0e271b2c5bdb463af3bb","29":"14941cf48fb8c4fc9942","30":"fbc3d0f6650602301bc1","31":"7736ec61c8ebdf90c129","32":"9ab809bdd123e62388cd","33":"6a701c04b4653696daea","34":"a2f5c10248d98f825f1e","35":"6d3cf25ddbb3421d2807","36":"5a191bcbd779581e7f2e","37":"0bc5449b0ff13ae40f92","38":"92e5ad335e8476796b94","39":"87c3709b8239ff6d6422","40":"f3b1c74b2fdcd3b81828","41":"21cc0a4ea4164dee3bec","42":"ca5b7aa0ea353ebf11be","43":"686d5d37ab3742270891","44":"c8fef80742db44e840dd","45":"9a22d32d4ba805acdc3d","46":"b3b853824c7c2108091b","47":"f8bbef09b38240aa33c7","48":"e963734e5f84d89baad9","49":"bc16f40ce0e2a9406260","50":"47168f5d40781a741d0d","51":"191199b81552981b32ed","52":"4d93c9d7bee9dd7e4752","53":"641d254f3a27fcd14e2e","54":"fb3bdba2994fc487c1b0","57":"5bbcc72a1e471a3c682e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"80a5ef906c00ddf5a39ef8dae21ccd4a61f15c69","3":"73578d5199b4d25220561732e5c3d040965c3d2e","4":"35fc8c20","5":"b35971fe2db1c9730b651c6a7f89f5bd5c72c54a","6":"8958a65904f2d4b1fb4a7e3327e99fe63d4db0d4","7":"a71dabd864de05638b49f8b70261c411cda1ef4e","8":"9519e63b9c9875fead001173bf2ac561d3fdf0c5","11":"component---src-pages-404-js","12":"component---src-pages-index-js","13":"component---src-templates-about-js","14":"component---src-templates-athena-issue-js","15":"component---src-templates-athena-issues-js","16":"component---src-templates-careers-index-js","17":"component---src-templates-case-study-js","18":"component---src-templates-contact-index-js","19":"component---src-templates-contact-success-js","20":"component---src-templates-custom-articles-cycle-1-defining-audiences-js","21":"component---src-templates-custom-articles-cycle-1-dscout-js","22":"component---src-templates-custom-articles-cycle-1-face-filters-js","23":"component---src-templates-custom-articles-cycle-1-fluid-brand-js","24":"component---src-templates-custom-articles-cycle-1-octopuses-js","25":"component---src-templates-custom-articles-cycle-1-you-dont-know-me-js","26":"component---src-templates-custom-articles-cycle-2-alternate-economies-js","27":"component---src-templates-custom-articles-cycle-2-interview-js","28":"component---src-templates-custom-articles-cycle-2-introduction-js","29":"component---src-templates-custom-articles-cycle-2-octopus-part-2-js","30":"component---src-templates-custom-articles-cycle-2-wayfinding-js","31":"component---src-templates-custom-articles-cycle-3-collective-genius-js","32":"component---src-templates-custom-articles-cycle-3-cooperative-aesthetics-js","33":"component---src-templates-custom-articles-cycle-3-cooperative-mindset-js","34":"component---src-templates-custom-articles-cycle-3-new-impact-models-js","35":"component---src-templates-custom-articles-cycle-4-endlesss-js","36":"component---src-templates-custom-articles-cycle-4-engestation-js","37":"component---src-templates-custom-articles-cycle-4-flourishing-js","38":"component---src-templates-custom-articles-cycle-4-joy-can-lead-us-js","39":"component---src-templates-custom-articles-cycle-4-rethinking-js","40":"component---src-templates-custom-articles-cycle-4-sounds-js","41":"component---src-templates-custom-articles-cycle-4-vocab-js","42":"component---src-templates-custom-articles-cycle-5-default-js","43":"component---src-templates-endlesss-js","44":"component---src-templates-expertise-entry-js","45":"component---src-templates-expertise-index-js","46":"component---src-templates-newsletter-js","47":"component---src-templates-people-js","48":"component---src-templates-person-js","49":"component---src-templates-private-js","50":"component---src-templates-project-js","51":"component---src-templates-recruit-index-js","52":"component---src-templates-recruit-success-js","53":"component---src-templates-tertiary-page-js","54":"component---src-templates-works-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"5120b992fcc183604f13","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
